module.exports = __webpack_public_path__ + "img/Clique_sur_signaler.498e517c.png";